import { REQUEST_URL } from "../app/constants";
import { RequestUtil } from "../utils";

export const ChatService = {
  sendMessage: (message: string, sessionId?: string) => {
    const url = REQUEST_URL.HR_CHAT;
    return RequestUtil.post({
      url,
      data: { message, sessionId },
    });
  },

  getSessions: () => {
    const url = REQUEST_URL.HR_CHAT_SESSIONS;
    return RequestUtil.get({ url });
  },

  getSession: (id: string) => {
    const url = REQUEST_URL.HR_CHAT_SESSION.replace("{id}", id);
    return RequestUtil.get({ url });
  },

  deleteSession: (id: string) => {
    const url = REQUEST_URL.HR_CHAT_SESSION.replace("{id}", id);
    return RequestUtil.delete({ url });
  },
};
